module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_gc-8028b960a677a40afc631b7d0b69a6dd.png";